import { ILeague } from '../types';
import api, { apiAxios, getAccessToken } from './api';

export const getAvailableLeagues = async () => {
  const leaguesList = await api.get('leagues');
  
  return leaguesList.data;
};

export const getLeaguesApi = async ({ leagueType, search, matchStatus, activated, cursor }: any) => {
  await getAccessToken();
  const url = `leagues?take=100&activated=${activated}${leagueType ? '&leagueType=' +
    leagueType.toUpperCase() : ''}${search ? "&search=" + search : ""}${matchStatus ? "&matchTimeStatusCount=" + matchStatus : ""}
    ${cursor ? "&cursor=" + cursor : ""}`;
  
  return api.get(url);
};

export const editLeagueApi = async (newObj: ILeague) => {
  await getAccessToken();
  
  const newLeague = {
    ...newObj,
    activated: Boolean(newObj.activated) ? 'true' : 'false',
    isPaid: Boolean(newObj.isPaid) ? 'true' : 'false',
  };
  
  const updatedLeague = await api.put('leagues', { data: newLeague })
  return updatedLeague.data;
};

export const getMoreLeaguesApi = async (id: string) => {
  return apiAxios(`/leagues?cursor=${id}&activated=true`);
};
